<script lang="ts">
    import Reload from "svelte-radix/Reload.svelte";
    import { t } from 'svelte-i18n'
</script>

<p>  <Reload class="mr-2 h-4 w-4 animate-spin" /> {$t('global.messages.loading')}</p>